"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityStatusFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const dates_1 = require("../../type-checking/dates");
const objects_1 = require("../../type-checking/objects");
const primitives_1 = require("../../type-checking/primitives");
const typing_1 = require("../../type-checking/typing");
class AvailabilityStatusFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                emoji: primitives_1.isStringValue,
                status: primitives_1.isStringValue,
                selected_interval: primitives_1.isStringValue,
                clear_after: (0, typing_1.Optional)(dates_1.isDateValue),
            });
        };
        this.getEmptyValue = () => {
            return (0, get_value_1.getAvailabilityStatusFieldEmptyValue)();
        };
    }
}
exports.AvailabilityStatusFieldValueGetter = AvailabilityStatusFieldValueGetter;
